import { keys, reduce } from "lodash";
import { InputError } from "../../../hooks/use-form";
import { ApplicationStep2 } from "../../../models/classes/ApplicationStep2.class";
import { SharedValidators } from "../shared/validators";


export const validateStageBFinancing = (values: ApplicationStep2, additional_values:any) => {
  const { isLoginRetaining, isLoginOutgoing, isMainRetaining } = additional_values;
  const fields = keys(values);
  const errors: any = reduce(
    fields,
    (result, field: string) => {
      // The stage B financing section will be always true when isLoggedIn use is outgoing OR isMain retaining and isLogin retaining
      if(isLoginOutgoing || (isMainRetaining && isLoginRetaining)){
        return { ...result, [field]: { isValid: true }};
      }
      let validatedResult = validateStageBFinancingFields(values, field);
      return { ...result, [field]: validatedResult };
    },
    {}
  );
  return errors;
};

const validateStageBFinancingFields = (values: any, name: string) => {
  const value = values[name];

  let error: InputError | undefined = { isValid: true };

  if(name === "new_loan_type"){
    error = SharedValidators.BasicEmptyUndefined(value);
  }

  return error;
};

